import { List, ListItem, ListItemText, Typography } from "@mui/material";

import { PartnerHistoryEntry } from "@modules/partners/types";

interface HistoryTimelineProps {
  entries?: PartnerHistoryEntry[];
}

export function HistoryTimeline({ entries }: HistoryTimelineProps) {
  if (!entries?.length) {
    return <Typography color="text.secondary">—</Typography>;
  }

  return (
    <List dense>
      {entries.map((entry) => (
        <ListItem key={entry.id} divider>
          <ListItemText
            primary={`${entry.action}${entry.actor ? ` — ${entry.actor}` : ""}`}
            secondary={[
              new Date(entry.created_at).toLocaleString("pt-BR"),
              entry.changes ? JSON.stringify(entry.changes) : null,
            ]
              .filter(Boolean)
              .join(" · ")}
          />
        </ListItem>
      ))}
    </List>
  );
}
